// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_13qgnJrGGSF7HmcTPltEMw"};